import { useContext, useState } from 'react';
import { DetailsDialog } from '@components/DetailsDialog/DetailsDialog';
import { AssetContext } from '@pages/Asset/Asset.query';
import { Icon as BlueIcon } from '@blueprintjs/core';

// import { Menu } from './Components/Menu/Menu';
import { CreateUpdatesDialog } from '@components';
import { useQuery } from 'react-query';
import { showProductsCreateUpdate } from '@services/queries/products';
import ReactTooltip from 'react-tooltip';
import { getProductValue } from '@utils/getProductValue';
import { useSelector } from 'react-redux';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { NoUpdates } from './Components/NoUpdates/NoUpdates';
import { TempProduct } from './Components/TempProduct/TempProduct';
import { AssetUpdatesContext } from './Updates.query';
import { Search } from '../Search/Search';

import {
  Container,
  Title,
  Head,
  Counter,
  WrapperRow,
  Divider,
  Buttons,
  WrapperHeaderRow,
  Add,
  HelpToolTipTextDiv,
} from './Updates.styles';
import { NewTable } from './Components/NewTable/NewTable';
import { CountLoading, UpdatesLoading } from './Updates.loading';
import {
  makeShortcutRefCallback,
  shortcuthashes,
} from '../Sidebar/components/Shortcuts/Shortcuts.utils';
import { NoFeatureMenu } from './Components/NoFeatureMenu/NoFeatureMenu';

export const UpdatesRaw = () => {
  const { search, updateStatusId, updatesQuery } =
    useContext(AssetUpdatesContext);
  const { equipmentQuery, shortcutRefs } = useContext(AssetContext);

  const [openCreateUpdates, setOpenCreateUpdates] = useState(false);

  const equipment = equipmentQuery?.data;

  const { productId } = equipment || {};
  const productRawQuery = useQuery(
    ['createUpdate', 'products', productId],
    () => {
      if (!productId) return null;
      return showProductsCreateUpdate({
        productId,
      });
    },
    {
      enabled: !!equipment,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );

  const { product } = equipment || {};
  const productData = getProductValue(equipment);
  const showUpdate = () => {
    if (updatesQuery?.isLoading) {
      return <UpdatesLoading />;
    }

    if (updatesQuery?.data?.length === 0) {
      if (product?.tempProductId) {
        return <TempProduct />;
      }

      return <NoUpdates />;
    }

    return <NewTable />;
  };

  const count = () => {
    return updatesQuery?.data?.length || 0;
  };

  const isCountLoading = () => {
    return updatesQuery?.isLoading;
  };

  const { isDesktop, isMobile } = useSelector(checkDevice());
  const refCallback = makeShortcutRefCallback(
    shortcutRefs,
    shortcuthashes.updates,
  );
  return (
    <Container ref={refCallback}>
      <Head>
        <WrapperRow>
          <Title>{productData.model} Updates</Title>
          {isCountLoading() ? <CountLoading /> : <Counter>{count()}</Counter>}
        </WrapperRow>
        <WrapperHeaderRow>
          {isDesktop && (
            <Buttons>
              <Search loadSearch={search.set} helperText="Find an update" />
              <Add
                onClick={() => setOpenCreateUpdates(true)}
                data-tip
                data-for="addProductUpdateTooltip"
              >
                <BlueIcon icon="plus" color="#8F95B2" />
              </Add>
              <ReactTooltip
                className="tooltip"
                id="addProductUpdateTooltip"
                effect="solid"
                place="bottom"
                multiline
                backgroundColor="#161A30"
              >
                <HelpToolTipTextDiv>
                  Add an update for this product
                </HelpToolTipTextDiv>
              </ReactTooltip>
            </Buttons>
          )}
          {isMobile && <NoFeatureMenu />}
        </WrapperHeaderRow>
      </Head>

      <Divider height="24px" />

      {showUpdate()}

      {updateStatusId.get() && (
        <DetailsDialog
          open={!!updateStatusId.get()}
          onClose={() => {
            updateStatusId.set(null);
          }}
          updateId={updateStatusId.get() as string}
        />
      )}

      <CreateUpdatesDialog
        open={openCreateUpdates}
        onClose={() => setOpenCreateUpdates(false)}
        tab="affected"
        relatesToPrev="products"
        productPrev={productRawQuery?.data ?? undefined}
      />
    </Container>
  );
};
